import * as React from "react";

interface Props {
  width?: number;
  height?: number;
}

export const OpenChatIcon: React.FC<Props> = ({ width, height }) => (
  <div
    style={{
      width: width || 24,
      height: height || 24,
    }}
  >
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11" fill="none" stroke="#52525b" strokeWidth="1.5" />

      <path d="M8 8 L16 8 M12 8 L12 16" stroke="#52525b" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="12" r="2" fill="none" stroke="#52525b" strokeWidth="1.5" />
      <circle cx="16" cy="12" r="2" fill="none" stroke="#52525b" strokeWidth="1.5" />
    </svg>
  </div>
);
